// Synthetic node id shared by both test-mode flows so the `?node=` param opens whichever renders.
export const TEST_MODE_NODE_ID = 'test-mode';

export const DEFAULT_BOOTSTRAP_DATA = `{
  // "id.phone_number": "+15555550100",
  // "id.email": "john.doe@example.com",
  // "id.first_name": "John",
  // "id.last_name": "Doe",
  // "id.dob": "1990-01-01",
  // "id.address_line1": "123 Main St",
  // "id.address_line2": "Apt 1",
  // "id.city": "Anytown",
  // "id.state": "CA",
  // "id.zip": "12345",
  // "id.country": "US",
  // "id.ssn9": "123456789",
}`;

export const DEFAULT_BUSINESS_BOOTSTRAP_DATA = `{
  // "business.name": "Acme Inc",
  // "business.dba": "Acme",
  // "business.website": "https://acme.com",
  // "business.phone_number": "+15555550100",
  // "business.tin": "121231234",
  // "business.address_line1": "123 Main St",
  // "business.address_line2": "Apt 1",
  // "business.city": "Anytown",
  // "business.state": "CA",
  // "business.zip": "12345",
  // "business.country": "US",
}`;

export const DEFAULT_OB_DATA = `{
  // "example_key": "example_value",
}`;

// Verified's sandbox fixture user. This phone and date of birth are the pair that returns a prefill
// match, and the number is one of the backend's fixture phones, so its SMS OTP is fixed rather than
// really sent (see `VERIFIED_PREFILL_FIXTURE_NUMBERS` in `newtypes/src/fields/phone_number.rs`).
export const VERIFIED_MATCH_PHONE = '+12125550022';
export const VERIFIED_MATCH_DOB = '1989-08-01';
export const VERIFIED_MATCH_OTP = '111111';
